import { render, staticRenderFns } from "./EmailDefaultTextPage.vue?vue&type=template&id=973ad654&scoped=true&lang=pug&"
import script from "./EmailDefaultTextPage.vue?vue&type=script&lang=ts&"
export * from "./EmailDefaultTextPage.vue?vue&type=script&lang=ts&"
import style0 from "./EmailDefaultTextPage.vue?vue&type=style&index=0&id=973ad654&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973ad654",
  null
  
)

export default component.exports